import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';
import { useState } from 'react';
import { getExtractAdminState } from '~/api/extract';
import SuperAdminLayout from '../common/SuperAdminLayout';
import AssignExtractTemplate from './AssignExtractTemplate';
import CreateExtractAutomation from './CreateExtractAutomation';
import CreateExtractTemplate from './CreateExtractTemplate';
import { EXTRACT_ADMIN_STATE_QUERY_KEY, EXTRACT_TOOL_TABS, type ExtractToolTabKey } from './common';
import ExtractState from './ExtractState';
import SyncProjections from './SyncProjections';

export default function ExtractTools() {
  const [activeTab, setActiveTab] = useState<ExtractToolTabKey>('sync');

  const {
    data: state,
    isLoading,
    isError,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: EXTRACT_ADMIN_STATE_QUERY_KEY,
    queryFn: getExtractAdminState,
  });

  return (
    <SuperAdminLayout>
      <div className="flex flex-col space-y-6" data-testid="extract-tools">
        <nav aria-label="Extract tools" className="flex gap-1 border-b border-grey-20" data-testid="extract-tools-tabs">
          {EXTRACT_TOOL_TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              data-testid={tab.testid}
              aria-current={activeTab === tab.key}
              className={classNames('-mb-px border-b-2 px-4 py-2 text-sm', {
                'border-blue-50 font-medium text-blue-50': activeTab === tab.key,
                'border-transparent text-grey-60 hover:text-grey-80': activeTab !== tab.key,
              })}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <div>
          {activeTab === 'sync' && <SyncProjections />}
          {activeTab === 'automation' && (
            <CreateExtractAutomation
              activeAutomationName={state?.automations.find((automation) => automation.status === 'active')?.name}
            />
          )}
          {activeTab === 'template' && <CreateExtractTemplate />}
          {activeTab === 'assign' && <AssignExtractTemplate templates={state?.activeTemplates ?? []} />}
          {activeTab === 'state' && (
            <ExtractState
              state={state ?? null}
              isLoading={isLoading}
              isError={isError}
              isFetching={isFetching}
              onRefresh={() => refetch()}
            />
          )}
        </div>
      </div>
    </SuperAdminLayout>
  );
}
